// @flow

import * as React from 'react'

type State = {
  clientHeight: number
};

export default function<Props: {}> (
  InnerComp: React.ComponentType<
    Props & {
      clientHeight: number
    }
  >
): React.ComponentType<Props> {
  return class extends React.PureComponent<Props, State> {
    constructor (props: Props) {
      super(props)

      this.state = {
        clientHeight: this.getClientHeight()
      }
      window.addEventListener('resize', this.updateHeight)
    }

    getClientHeight = (): number => {
      // $FlowFixMe
      return document.documentElement.clientHeight
    };

    componentWillUnmount () {
      window.removeEventListener('resize', this.updateHeight)
    }

    updateHeight = () => {
      this.setState({
        clientHeight: this.getClientHeight()
      })
    };

    render () {
      return (
        <InnerComp {...this.props} clientHeight={this.state.clientHeight} />
      )
    }
  }
}



// WEBPACK FOOTER //
// ./src/frame/hoc/clientHeight.js